import { useAuthStore } from '../stores/auth'

export default function auth({ roles = [], permissions = [] }) {
    const authStore = useAuthStore()

    if (!authStore.isAuthenticated) {
        return false
    }
    if (roles.length > 0 && !authStore.hasAnyRole(roles)) {
        return false
    }
    if (permissions.length > 0 && !authStore.hasAnyPermission(permissions)) {
        return false
    }

    return true
}